import React from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import AdminSubscriberDetail from './subscriptions/AdminSubscriberDetail';

const AdminSubscriberDetailPage = () => (
  <AdminLayout>
    <AdminSubscriberDetail />
  </AdminLayout>
);

export default AdminSubscriberDetailPage;
